module.exports = __webpack_public_path__ + "img/logo.50be06ac.png";